import { TxDocument } from './document.model';

export interface ITransactionSection {
  id: string;
  documents: TxDocument[];
}

export class TransactionSection implements ITransactionSection {
  constructor(public id: string, public documents: TxDocument[]) {}

  getDocumentsByClientId(clientId: string): TxDocument[] {
    return this.documents.filter((document) => document.hasSignerById(clientId));
  }
}
